import {minuteInMS} from "web-vcore";
import {EffectPointerPlayer} from "../../../../Server/DB/@Shared/EffectPointerPlayer.js";
import {AlarmSequence} from "../../../../Server/DB/engineConfigs/@EngineConfig/Alarms/@AlarmConfig.js";
import {EngineConfig_SoundAlarm} from "../../../../Server/DB/engineConfigs/@EngineConfig/Alarms/@EC_BasicAlarms.js";
import {nativeBridge} from "../../../../Utils/Bridge/Bridge_Native.js";
import {LiveSession} from "../../../LiveSession.js";
import {AlarmsComp} from "../AlarmsComp.js";
import {AlarmComp} from "./@AlarmComp.js";

export function GetStandardTTSVars(session: LiveSession) {
	const alarmsComp = session.Comp(AlarmsComp);
	const dreamingTimeSoFar = alarmsComp.phase == "dreaming" ? Date.now() - alarmsComp.phase_changedAt : 0;
	return {
		minsDreaming: dreamingTimeSoFar != null ? (dreamingTimeSoFar / minuteInMS).RoundTo(1).toString() : "",
	};
}

export class SoundAlarmComp extends AlarmComp<EngineConfig_SoundAlarm> {
	constructor(session: LiveSession, sequence: AlarmSequence, config: EngineConfig_SoundAlarm) {
		super(session, sequence, config);
	}

	promptPlayer = new EffectPointerPlayer();

	override OnStart() {
		this.promptPlayer.effectPointer = this.c.effectPointer;
		this.promptPlayer.OnStart();
	}
	override OnStop() {
		this.promptPlayer.Stop();
		return super.OnStop();
	}

	override async PlayAlarmEffect(playCountThisSequence: number) {
		await this.promptPlayer.Play(this.intensity, {
			playCountThisSequence,
			ttsVars: GetStandardTTSVars(this.s),
		});
	}
	override UpdatePrompt_ForReducedIntensity() {
		this.promptPlayer.NotifyReducedIntensity(this.intensity);
	}
	override StopAlarm(...args: Parameters<AlarmComp<any>["StopAlarm"]>) {
		/*if (this.c.controlBackgroundAudio) {
			this.s.Comp(BackgroundComp).backgroundSoundPlayer.SetLiveVolume(this.s.Comp(BackgroundComp).volume); // background and prompt players are the same, in this case, so just reset volume
			return;
		}*/
		this.promptPlayer.Stop();
		return super.StopAlarm(...args);
	}
}